var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"clrm-footer",class:'clrm-footer--' + _vm.classroomMode},[_c('div',{staticClass:"clrm-container-fluid"},[_c('p',[_vm._v("© "+_vm._s(_vm.year)+", Instituto Interculturas")])])])}
var staticRenderFns = []

export { render, staticRenderFns }